import Vue from "vue";
import { HigriConvert } from "@/helpers/higridate";

let HigriPipe = new HigriConvert();

Vue.filter("hijriFormat", function (value) {
  if (!value) return "";
  let formattedDate = HigriPipe.getHigriArabic(value);
  return formattedDate;
});

Vue.filter("hijriGregoni", function (value) {
  if (!value) return "";
  let formattedDate = HigriPipe.getGregoni(value);
  return formattedDate;
});

Vue.filter("fullHijriFormat", function (value) {
  
  if (!value) return "";
  let formattedDate = HigriPipe.getFullHigriArabic(value);
  return formattedDate;
});
Vue.filter("fullHijriFormatWithoutTime", function (value) {
  
  if (!value) return "";
  let formattedDate = HigriPipe.getFullHigriArabicWithoutTime(value);
  return formattedDate;
});

Vue.filter("hijriFormatNew", function (value) {
  if (!value) return "";
  return value;
});

Vue.filter("shortTitle", (value) => {
  if (!value) {
    return "";
  } else if (value.length < 20) {
    return value;
  } else if (value.length >= 20) {
    return `${value.slice(0, 20)}  ... `;
  }
});